export default "__VITE_ASSET__05dab132__"